export default __webpack_public_path__ + "static/Resume-CodySehl-32774725e6a6f6446cffbb837c05200f.pdf";